<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="posi-from">
          <div class="posi-item mb-36">
            <div class="posi-item-title">
              <div class="posi-line"></div>
              {{ dataVal.text1 }}
            </div>
            <div class="posi-item-input">
              <el-input
                placeholder="请输入"
                type="textarea"
                maxlength="300"
                show-word-limit
                v-model="fileObj.info"
              ></el-input>
            </div>
          </div>
          <div class="posi-item mb-36">
            <div class="posi-item-title">
              <div class="posi-line"></div>
              {{ dataVal.text2 }}
            </div>
            <div class="posi-item-input">
              <el-upload
                ref="upload"
                class="upload-demo"
                drag
                :headers="headers"
                :action="uploadfile"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :file-list="fileList2"
                multiple
              >
                <div class="drag">
                  <img src="@/assets/images/basicBusiness/upload.png" alt="" />
                  <div>请点击上传附件或拖动到此位置上传</div>
                </div>
              </el-upload>
            </div>
            <div class="posi-upload">
              <div
                class="posi-upload-item"
                v-loading="item.percent != 100 && item.statusbar == '上传中'"
                element-loading-text="上传中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                v-for="(item, i) in fileList"
                :key="item.uid"
                @click="handleRemove(i)"
              >
                <div>{{ item.url }}</div>
                <i class="el-icon-circle-close"></i>
              </div>
            </div>
          </div>
          <div class="posi-item">
            <div class="posi-item-title">
              <div class="posi-line"></div>
              {{ dataVal.text3 }}
            </div>
            <div class="v-footer">
              <div class="v-footer-item">
                <div>调整后：</div>
                <div>
                  <el-rate
                    v-model="fileObj.backrank"
                    void-color="#AEAEB2"
                    @change="handleChange"
                  ></el-rate>
                </div>
              </div>
              <div class="v-footer-item">
                <div>原始等级：</div>
                <div>
                  <el-rate
                    v-model="rate"
                    disabled-void-icon-class="el-icon-star-off"
                    disabled-void-color="#AEAEB2"
                    disabled
                  ></el-rate>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      headers: {
        token: localStorage.getItem("token"),
        type: localStorage.getItem("type"),
      },
      fileList: [],
      fileList2: [],
      fileObj: {
        yuesao_id: "",
        info: "",
        backrank: "",
        attach: "",
        id: "",
      },
      rate: "",
    };
  },
  mounted() {},
  methods: {
    handleChange(e) {
      if (this.rate == 0) {
        this.fileObj.backrank = 0;
        return false;
      }
      if (this.fileObj.backrank > this.rate) {
        this.fileObj.backrank = this.rate;
        return false;
      }
    },
    //上传中
    handleProgress(response, file, fileList) {
      console.log(file, 111);
      let i = -1;
      this.fileList.forEach((item, index) => {
        if (item.uid == file.uid) {
          console.log(index);
          this.fileList.splice(index, 1, {
            uid: file.uid,
            url: file.name,
            percent: response.percent,
            statusbar: "上传中",
          });
          i = index;
          if (response.percent == 100) {
            this.fileList.splice(index, 1);
          }
        }
      });
      if (i == -1 && response.percent != 100) {
        this.fileList.push({
          uid: file.uid,
          url: file.name,
          percent: response.percent,
          statusbar: "上传中",
        });
      }
    },
    handleSuccess(res, fileList) {
      this.fileList.push({
        uid: res.data.file,
        url: res.data.file,
        percent: 100,
        statusbar: "上传成功",
      });
    },
    handleRemove(index) {
      this.fileList.splice(index, 1);
    },
    //提交
    async handleSubmit() {
      let arr = this.fileList.map((item) => item.url);
      this.fileObj.attach = arr.toString();
      if (this.dataVal.isApi == "分销员") {
        this.fileObj.saler_id=this.fileObj.yuesao_id;
        let res = await this.$api.salerEditderegulation({
          ...this.fileObj,
        });
        if (res.code == 1) {
          let obj = {
            flag: false,
            submitFlag: true,
          };
          this.$emit("addingRecordCell", obj);
          this.$message.success(res.msg);
        } else {
        }
        return false;
      }
      let res = await this.$api.yuesaoEditderegulation({
        ...this.fileObj,
      });
      if (res.code == 1) {
        let obj = {
          flag: false,
          submitFlag: true,
        };
        this.$emit("addingRecordCell", obj);
        this.$message.success(res.msg);
      } else {
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addingRecordCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.type == "add") {
          this.fileObj.yuesao_id = newVal.id;
          this.fileObj.backrank = Number(newVal.rank);
          this.rate = Number(newVal.rank);
          this.fileObj.info = "";
          this.fileList = [];
          this.fileList2 = [];
        } else {
          this.fileObj.yuesao_id = newVal.id;
          if (newVal.item.attach) {
            this.fileList = newVal.item.attach.split(",").map((item) => ({
              uid: item,
              url: item,
              percent: 100,
              statusbar: "上传成功",
            }));
          } else {
            this.fileList = [];
          }
          this.fileObj.info = newVal.item.info;
          this.rate = newVal.item.srcrank;
          this.fileObj.backrank = newVal.item.backrank;
          this.fileObj.id = newVal.item.id;
        }
      },
      deep: true,
    },
  },
};
</script>
    <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 1016px;
  height: 75vh;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .posi-over {
    height: calc(80vh - 235px);
    padding: 21px 41px 0;
    overflow: auto;
  }
  .posi-from {
    .posi-item {
      width: 100%;
      .posi-item-title {
        color: #000;
        font-size: $f-size-13;
        font-weight: 600;
        margin-bottom: 11px;
        display: flex;
        align-items: center;
        span {
          color: #ff3b30;
          font-size: $f-size-13;
        }
        .posi-line {
          width: 6px;
          height: 18px;
          border-radius: 2px;
          background-color: $y-color;
          margin-right: 6px;
        }
      }

      .posi-item-input {
        width: 100%;
        input {
          width: 100%;
          height: 52px;
          background-color: #f5f6fa;
          color: #000;
          font-size: 14px;
          border: 1px solid #d5d5d5;
          outline: none;
          padding-left: 16px;
        }
        /deep/.upload-demo {
          .el-upload {
            width: 100%;
          }
          .el-upload-dragger {
            width: 100%;
            background-color: #f5f6fa;
            height: 60px;
          }
          .drag {
            @include flex-center(center, center);
            font-size: $f-size-13;
            color: #aeaeb2;
            height: 60px;
            img {
              width: 35px;
              height: 35px;
              margin-right: 9px;
            }
          }
        }
        /deep/.el-input__inner {
          height: 52px;
          line-height: 52px;
          background-color: #f5f6fa;
          color: #000;
          font-size: 14px;
          border: 1px solid #d5d5d5;
        }
        /deep/.el-textarea {
          width: 100%;
          .el-textarea__inner {
            height: 182px;
            width: 100%;
            background-color: #f5f6fa;
            color: #000;
            font-size: 14px;
            border: 1px solid #d5d5d5;
            resize: none;
            padding: 21px 29px;
          }
          .el-input__count {
            background-color: #f5f6fa;
            color: #000;
          }
        }
      }
      .posi-upload {
        @include flex-center(flex-start, center);
        flex-wrap: wrap;
        font-size: $f-size-13;
        color: $y-color;
        .posi-upload-item {
          margin: 13px 22px 13px 0;
          display: flex;
          align-items: center;
          padding: 10px 7px;
          border-radius: 5px;
          background-color: #f2f2f7;
          div {
            margin-right: 6px;
          }
          i {
            flex-shrink: 0;
            color: #d1d1d6;
            font-size: 15px;
            cursor: pointer;
            margin-top: 3px;
          }
        }
      }
      .v-footer {
        background-color: #f2f6ff;
        height: 40px;
        padding: 0 29px 0 18px;
        @include flex-center(center, center);
        .v-footer-item {
          @include flex-center(flex-start, center);
          div {
            font-size: 11px;
            font-weight: 700;
            color: #000;
          }
          &:first-child {
            margin-right: 235px;
          }
        }
      }
    }
    .mb-36 {
      margin-bottom: 28px;
    }
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #4a4b9d;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>